import { useState } from "react";
import NiceModal from "@ebay/nice-modal-react";

const InsertPhoneNumber = ({ next, getVerifyCode, phoneNumber, setPhoneNumber }: any) => {
    const [errors, setErrors] = useState<any>({});

    const validateForm = () => {
        let isvalid = true;
        let errors: any = {};
        if (phoneNumber.length !== 10 || !RegExp('\\d{10}').test(phoneNumber)) {
            errors["phoneNumber"] = "נראה שיש טעות במספר. המספר צריך להיות בן 10 ספרות, בלי רווחים או מקפים";
            isvalid = false;
        }
        setErrors(errors);
        return isvalid;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (validateForm()) {
            const res = await getVerifyCode(phoneNumber);
            if (res?.response?.data === "Phone number exists") {
                NiceModal.show("action_modal", {
                    onNext: () => NiceModal.hide("action_modal"),
                    headerTitle: "שגיאה",
                    contentTitle: "הטלפון קיים במערכת, נסה טלפון אחר",
                    seconderyButtonText: "",
                    primaryButtonText: "אישור",
                    showCloseButton: true,
                    showSeconderyButton: false
                });
            } else {
                next();
            }
        }
    };

    const enabled =
        phoneNumber.length > 0;


    return (
        <>
            <div className="content_sec wf-section">

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">אימות פרופיל</h2>
                    <p>שלב 1 מתוך 2</p>
                    <br />
                    <h4>אימות מספר הטלפון שלך</h4>
                    <div>בעזרת האימות נוכל לשמור על קהילה בטוחה יותר. אנחנו כמובן לא נחשוף את מספר הטלפון שלך</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit} >
                        <div className="form_field_content login">
                            <div className="field_block">
                                {/* <label htmlFor="phoneNumber">מספר טלפון</label> */}
                                <input autoComplete="off" type='tel' name="phoneNumber" value={phoneNumber} placeholder="מספר הנייד, ללא מקף" onChange={e => setPhoneNumber(e.target.value)} maxLength={10} className="txt_field tel w-input" />
                                <div style={{ display: errors && errors["phoneNumber"] ? "contents" : "block" }} className="form_allert">{errors["phoneNumber"]}</div>
                            </div>
                            <div className="field_block_comment">
                                {/* <b>הבטחה שלנו</b> */}
                            </div>
                            {/* <div className="field_block_comment">מספר הטלפון שלך לא יחשף</div> */}
                            <input autoComplete="off" disabled={!enabled} type="submit" value="אפשר להמשיך" data-wait="" className={enabled ? "button_full w-button" : "button_full inactive  w-button"}></input>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default InsertPhoneNumber;